import { select, on, addClass } from 'helpers/dom'

const selectors = {
  READ_MORE_CLASS: '.js-read-more'
}

class ShopSeoText extends HTMLElement {
  constructor() {
    super()
    this.buttonEl = select(selectors.READ_MORE_CLASS, this)
    on(
      'click',
      () => {
        addClass('open', this)
      },
      this.buttonEl
    )
  }
}

// graceful fail on already registered element
customElements.get('shop-seo-text') || customElements.define('shop-seo-text', ShopSeoText)
